

import React, { useState, useEffect } from "react";
import { View, ScrollView, SafeAreaView, StyleSheet, Picker, Text, TouchableOpacity,Image } from "react-native";
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from 'react-i18next';
import { i18n } from './../../../assets/lang/i18next';
const useStyles = makeStyles(() => ({
    textField: {
        width: "100%",
        marginTop: 20,
        marginLeft: "auto",
        marginRight: "auto",
        paddingBottom: 0,
        marginTop: 0,
        fontWeight: 500,
        fontSize: 13,
        direction: "rtl",
        "& .MuiFormLabel-root": {
            color: "black",
            textAlign: 'right',
            fontFamily: 'IranSans',
            fontSize: 13, direction: 'rtl', width: '100%',
        },
        "& .MuiInputLabel-asterisk": {
            color: '#d12023',
            fontWeight: 900,
        },
        "& .MuiInputBase-input": {
            color: '#333', textAlign: 'center'
        },
        '& label.Mui-focused': {
            color: '#333',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'yellow',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'white',
            },
            '&:hover fieldset': {
                borderColor: 'blue',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#333',
            },
        },

    },
    labelRoot: {
        right: 20,
    },
    shrink: {
        transformOrigin: "top right",
    },
    input: {
        color: "black", fontFamily: 'IranSans',
        fontSize: 13,

    },
    btn_calculate: {
        color: '#333',
        backgroundColor: 'gray',
        fontFamily: 'IranSans',
        fontSize: 13, fontWeight: 900,
    }
}));

const EvapratorByComp = props => {
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const [MSGSardkganeSelected, setMSGSardkganeSelected] = useState('');
    const [isshowkarbari, setIsshowkarbari] = useState(false);
    const [mobared, setMobared] = useState("R22");
    const [brandcomprosor, setBrandcomprosor] = useState(1);
    const [dbdamaytagh, SetDbdamaytagh] = useState('');
    const [dbdamaynahai, SetDbdamaynahai] = useState('');
    const [dbzekhamatdivar, SetDbzekhamatdivar] = useState('');
    const [dbzamansardsazi, SetDbzamansardsazi] = useState('');
    const [dbzaribbargiri, SetDbzaribbargiri] = useState('');
    const [dbdamayvorod, SetDbdamayvorod] = useState('');
    const [dbzarfiyatvijeh, SetDbzarfiyatvijeh] = useState('');
    const [dbafterenjemad, SetDbafterenjemad] = useState('');
    const [dbbeforeenjemad, SetDbbeforeenjemad] = useState('');
    const [dbenjemad, SetDbenjemad] = useState('');
    const [dbtanafosi, SetDbanafosi] = useState('');
    const [dbdeltatcomp, setDbDeltatComp] = useState(0);
    const [modelcomprosor, Setmodelcomprosor] = useState();
    const [tc, setTc] = useState("40");
    const [karbari, setKarbari] = useState(0);
    const [itemsCompTemp, setCompTempItems] = useState([]);
    const [datacomprosor, setComprosorData] = useState(() => { item => setComprosorData(item) });
    const [filterkarbord,setFilterkarbord]=useState();
    function GetInfoSardkhane(idsimpleprdt) {
        setKarbari(idsimpleprdt);
        fetch(`https://app.arshehkar.com/query/public/GetDataSimpleCal.php?id=${idsimpleprdt}`)
            .then(response => response.json())
            .then(async (responseJsontmp) => {
                SetDbdamaytagh(responseJsontmp["temproom"]);
                SetDbdamaynahai(responseJsontmp["finaltemp"]);
                SetDbzekhamatdivar(responseJsontmp["zekhamatdivarsaghf"]);
                SetDbzamansardsazi(responseJsontmp["zamansardsazi"]);
                SetDbzaribbargiri(responseJsontmp["zaribbargiri"]);
                SetDbdamayvorod(responseJsontmp["damayvorodmahsol"]);
                SetDbzarfiyatvijeh(responseJsontmp["zarfiyatgarmaeivijeh"]);
                SetDbafterenjemad(responseJsontmp["zarfiyatafter"]);
                SetDbbeforeenjemad(responseJsontmp["zarfiyatbefore"]);
                SetDbenjemad(responseJsontmp["damayenjemad"]);
                SetDbanafosi(responseJsontmp["zaribtanafos"]);
                setDbDeltatComp(responseJsontmp["deltatcomp"]);
                //   SetTe(((parseFloat(responseJsontmp["temproom"]) - parseFloat(responseJsontmp["deltatcomp"])) < parseFloat("-45") && (parseFloat(responseJsontmp["temproom"]) - parseFloat(responseJsontmp["deltatcomp"])) > parseFloat("-48")) ? "-45" : (parseFloat(responseJsontmp["temproom"]) - parseFloat(responseJsontmp["deltatcomp"])));
            })
    }
    function LISTComprosor(bndcomp, typemobared, motor) {
        fetch(`https://app.arshehkar.com/query/public/GetListCompByBrandDevice.php?brand=${bndcomp}&device=${typemobared}&motor=${motor}&sardchoice=${karbari}`)
            .then(response => response.json())
            .then(async (datacomprosor) => {
                const mapArray = datacomprosor.map(({ title, id }) => ({ label: title, value: title }));
                setCompTempItems(mapArray);
                if (datacomprosor.length > 0) {
                    Setmodelcomprosor(datacomprosor[0]["title"]);

                }

            })
    }
    function FUNCMOHASEBEH() {
        let te = 0, qn = 0, deltat = 0;
        if (karbari != 0) {

            switch (karbari) {
                case "1":
                    te = -20;
                    break;
                case "2":
                    te = -5;
                    break;
                case "3":
                    te = -5;
                    break;
                case "4":
                    te = -25;
                    break;
                case "5":
                    te = -5;
                    break;
            }

            switch (tc) {
                case "40":
                    deltat = 13
                    break;
                case "45":
                    deltat = 11
                    break;
                case "50":
                    deltat = 9
                    break;
            }



            let modelif = "HCH";
            fetch(`https://app.arshehkar.com/query/public/GetKWCompByTcTeCond.php?te=${te}&tc=${tc}&comp_brand=${brandcomprosor}&device=${mobared}&title=${modelcomprosor}`)
                .then(response => response.json())
                .then(async (responseJsontmp) => {

                    if (responseJsontmp.length > 0) {
                        qn = (responseJsontmp[0]["ans"] * 15) / (deltat);
                        switch (mobared) {
                            case "R22":
                                qn = qn;
                                break;
                            case "R134":
                                qn = parseFloat(qn) * parseFloat(0.97);
                                break;
                            case "R404a/R507a":
                                qn = parseFloat(qn) * parseFloat(1.05);
                                break;
                        }

                   
                       props.navigation.navigate('CondenserResult', { WHICH: 2, QN: qn, MODELIF: modelif });
                    }
                    else
                        alert(t('Sorrynoresultsfound'));

                   
                })
        }
        else
            alert(t('selectyourcoldroomapplication'));
    }



    React.useEffect(() => {
if (karbari!=0)
        LISTComprosor(brandcomprosor, mobared,filterkarbord);

    }, [brandcomprosor,karbari]);

    return (
        <ScrollView>
            <SafeAreaView style={styles.container}>
        

                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'space-between', width: '90%' }}>

                    <TouchableOpacity style={{ marginTop: 15, flex: 1, flexDirection: 'row' }} onPress={() => props.navigation.navigate('CompCondonser')}>
                        <Image resizeMode="contain" source={require('../../../assets/icons/comparisonicon.png')} style={{ width: 35, height: 35 }} />
                        <Text style={{ fontSize: 12, marginTop: 7, fontFamily: 'IranSans', color: 'blue' }}>{t('ComparisonCondenser')}</Text>
                    </TouchableOpacity>
                    <Text style={{ fontFamily: 'IranSans', fontWeight: 900, fontSize: 14, marginTop: 15, marginBottom: 10 }}>{t('HorizontalCondenser4&5series')}</Text>

                </View>


                <View style={styles.form}>
                    <Text style={styles.titleform}>{t('selectyourrefrigerant')}</Text>
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            setMobared(itemValue);
                            //LISTComprosor(brandcomprosor, itemValue);
                        }}
                    >
                        <Picker.Item label="R22" value="R22" />
                        <Picker.Item label="R134" value="R134" />
                        <Picker.Item label="R404a/R507a" value="R404a/R507a" />

                    </Picker>
                    <Text style={styles.titleform}>{t('condenserusage')}</Text>
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            setKarbari(itemValue);
                            switch (itemValue) {
                                case '1':
                                     // LISTComprosor(brandcomprosor, mobared, 1);   
                                      setFilterkarbord(1);
                                      GetInfoSardkhane(itemValue);
                                    break;
                                case '2':
                                  //  LISTComprosor(brandcomprosor, mobared, 1);   
                                    setFilterkarbord(1);                               
                                    GetInfoSardkhane(itemValue);                                                                    
                                    break;
                                case '3':
                                  //  LISTComprosor(brandcomprosor, mobared, 1);  
                                    setFilterkarbord(1);                                
                                    GetInfoSardkhane(itemValue);
                                    break;
                                case '4':
                                //    LISTComprosor(brandcomprosor, mobared, 3);   
                                    setFilterkarbord(3);                               
                                    GetInfoSardkhane(itemValue);
                                    break;
                                case '5':
                                   // LISTComprosor(brandcomprosor, mobared, 1);    
                                    setFilterkarbord(1);                              
                                    GetInfoSardkhane(itemValue);
                                    break;
                                default:
                                   // setIsshowkarbari(true);
                            }

                        }}
                    >
                        <Picker.Item label={t('select')} value="0" />
                        <Picker.Item label={t('below-zerocoldroom')} value="1" />
                        <Picker.Item label={t('above-zerocoldroom')} value="2" />
                        <Picker.Item label={t('chilingstorage')} value="3" />
                        <Picker.Item label={t('blastfreezer')} value="4" />
                        <Picker.Item label={t('airconditioning')} value="5" />
                    </Picker>
                    {isshowkarbari === true ?
                        <Text style={{ padding: 7, color: 'blue', fontSize: 12, fontFamily: 'IranSans', backgroundColor: '#d6d6d6', marginLeft: '10%', marginRight: '10%', borderRadius: 6, marginBottom: 7 }}>
                            {MSGSardkganeSelected}
                        </Text>
                        : null}


                    <Text style={styles.titleform}>{t('compressortype')}</Text>
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            setBrandcomprosor(itemValue);
                          //  LISTComprosor(itemValue, mobared,karbari == "4" ? 3 : 1);
                        }}
                    >
                        <Picker.Item label={t('Bitzer')} value="1" />
                        <Picker.Item label={t('Bock')} value="2" />
                    </Picker>

                    <Text style={styles.titleform}>{t('Compressormodel')}</Text>
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            Setmodelcomprosor(itemValue);
                        }}
                        value={modelcomprosor}
                    >
                      
                        {itemsCompTemp.map((item, index) => {
                            return (
                                <Picker.Item
                                    key={index}
                                    label={item.label}
                                    value={item.value}
                                />
                            )
                        }
                        )
                        }


                    </Picker>


                    <Text style={styles.titleform}>{t('Weathercondition')}</Text>
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            setTc(itemValue);
                        }}
                    >
                        <Picker.Item label={t('ColdRegions')} value="40" />
                        <Picker.Item label={t('TemperateRegions')} value="45" />
                        <Picker.Item label={t('TropicalRegions')} value="50" />
                    </Picker>

                    <TouchableOpacity onPress={() => {

                        FUNCMOHASEBEH();

                    }} style={{ backgroundColor: '#022a4c', color: 'white', padding: 15, margin: 15, borderRadius: 4 }}>
                        <Text style={styles.titlebutton}>
                            {t('Computing')}
                        </Text>
                    </TouchableOpacity>




                </View>
            </SafeAreaView>
        </ScrollView>
    )
}

export default EvapratorByComp;

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        backgroundColor: '#ebecec',

    }
    ,
    titleform: {
        marginBottom: 10,
        marginTop: 10,
        fontFamily: 'IranSans',
        fontSize: 13,
    }
    ,
    inputtext: {
        backgroundColor: '#fff',
        textAlign: 'center',
        borderColor: "gray",
        width: "100%",
        borderWidth: 1,
        borderRadius: 10,
        padding: 10, width: '100%', height: 30
    }
    ,
    dropdown: {
        height: 50,
        width: '100%',
        marginBottom: 10,
        fontFamily: 'IranSans',
        fontSize: 13,
        borderWidth: 0,
        textAlign: 'center',
        backgroundColor: '#c9c9c9',
        direction: 'rtl',



    },
    form: {
        width: '90%',
        backgroundColor: '#ddd',
        margin: 10,
        padding: 10,
        justifyContent: 'center',
        alignItems: 'stretch',
        shadowColor: '#000',
        shadowOffset: { width: 1, height: 0.5 },
        shadowOpacity: 0.7,
        shadowRadius: 3,
    }
    ,
    touchable: {
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 12,
        paddingHorizontal: 32,
        borderRadius: 4,
        elevation: 3,
        backgroundColor: 'blue',
        marginBottom: 15,
        margin: 15,
    },
    titlebutton: {

        fontSize: 13,
        lineHeight: 21,
        fontWeight: 'bold',
        fontFamily: 'IranSans',
        letterSpacing: 0.25,
        color: 'white',
        textAlign: 'center',

    },
    spinner: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: 'rgba(50,70,110,0.3)',
        bottom: 0,
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9000,
    }

});
